import { news } from "@/mocks/news";
import { videos } from "@/mocks/videos";
import { specials } from "@/mocks/specials";
import { categories } from "@/mocks/categories";

export type NewsItem = (typeof news)[number];
export type VideoItem = (typeof videos)[number];
export type SpecialItem = (typeof specials)[number];

export function getCategoryName(key: string): string {
  const found = categories.find((c) => c.key === key);
  return found ? found.name : "娱乐资讯";
}

export function getNewsById(id: string): NewsItem | undefined {
  return news.find((n) => n.id === id);
}

export function getVideoById(id: string): VideoItem | undefined {
  return videos.find((v) => v.id === id);
}

export function getSpecialById(id: string): SpecialItem | undefined {
  return specials.find((s) => s.id === id);
}

export function getNewsByCategory(key: string): NewsItem[] {
  return news.filter((n) => n.category === key);
}

export function getVideoTypeName(key: string): string {
  const map: Record<string, string> = {
    drama: "影视剧",
    variety: "综艺",
    short: "短视频",
  };
  return map[key] || "视频";
}

export function formatViews(views: number): string {
  if (views >= 10000) {
    return `${(views / 10000).toFixed(1)}万`;
  }
  return `${views}`;
}

export function relatedNews(current: NewsItem, limit = 3): NewsItem[] {
  return news
    .filter(
      (n) =>
        n.id !== current.id &&
        (n.category === current.category ||
          n.tags.some((t) => current.tags.includes(t))),
    )
    .slice(0, limit);
}

export function relatedVideos(current: VideoItem, limit = 3): VideoItem[] {
  return videos
    .filter(
      (v) =>
        v.id !== current.id &&
        (v.type === current.type || v.tags.some((t) => current.tags.includes(t))),
    )
    .slice(0, limit);
}

export interface SearchResult {
  kind: "news" | "video";
  id: string;
  title: string;
  summary: string;
  cover: string;
  date: string;
  meta: string;
}

export function searchAll(keyword: string): SearchResult[] {
  const kw = keyword.trim().toLowerCase();
  if (!kw) return [];
  const newsHits: SearchResult[] = news
    .filter(
      (n) =>
        n.title.toLowerCase().includes(kw) ||
        n.summary.toLowerCase().includes(kw) ||
        n.tags.some((t) => t.toLowerCase().includes(kw)),
    )
    .map((n) => ({
      kind: "news" as const,
      id: n.id,
      title: n.title,
      summary: n.summary,
      cover: n.cover,
      date: n.date,
      meta: getCategoryName(n.category),
    }));
  const videoHits: SearchResult[] = videos
    .filter(
      (v) =>
        v.title.toLowerCase().includes(kw) ||
        v.description.toLowerCase().includes(kw) ||
        v.tags.some((t) => t.toLowerCase().includes(kw)),
    )
    .map((v) => ({
      kind: "video" as const,
      id: v.id,
      title: v.title,
      summary: v.description,
      cover: v.cover,
      date: v.date,
      meta: getVideoTypeName(v.type),
    }));
  return [...newsHits, ...videoHits];
}